import React from 'react';
import ReactMarkdown from 'react-markdown';
import coalesceWithEmptyString
  from '@fuww/library/src/lib/coalesceWithEmptyString';
import filterImageUrls from './filterImageUrls';
import transformJob from './transformJob';

export default function getTemplateProperties(
  job: ReturnType<typeof transformJob>,
  locale: string,
) {
  const {
    mergedProperties,
    profiles,
    applyForm,
    applyUrl: jobApplyUrl,
    active,
  } = job;
  const applyUrl = applyForm ? 'job-apply' : jobApplyUrl;

  const templateProperties: {
    job: typeof job;
    locale: string;
    applyUrl: string | null;
    profiles: Record<string, typeof profiles[0]>;
    [key: string]: (string | null)[]
    | React.ReactElement
    | Record<string, typeof profiles[0]>
    | string[]
    | string
    | typeof job
    | null
    | undefined;
  } = {
    job,
    locale,
    applyUrl: active && applyUrl ? applyUrl : '',
    profiles: Object.fromEntries(
      profiles.map(
        (profile) => [profile.page.slug, profile],
      ),
    ),
  };

  mergedProperties.forEach(({
    name,
    value,
    type,
    imageUrls,
  }) => {
    const valueOrEmptyString = coalesceWithEmptyString(value);
    switch (type) {
      case 'html': {
        templateProperties[name] = (
          // eslint-disable-next-line react/no-danger
          <div dangerouslySetInnerHTML={{ __html: valueOrEmptyString }} />
        );
        break;
      }

      case 'markdown': {
        templateProperties[name] = (
          <ReactMarkdown>
            { valueOrEmptyString }
          </ReactMarkdown>
        );
        break;
      }

      default: {
        const imageUrl = filterImageUrls(imageUrls);
        templateProperties[name] = imageUrl ?? value;
        break;
      }
    }
  });

  return templateProperties;
}
